import type { ModelType } from "../../../../../common-deprecated/types/CommonTypes";

export const SET_MODEL = "model/set" as const;

type SetModelType = { type: typeof SET_MODEL; model: ModelType };

export const setModel = (model: ModelType): SetModelType => ({ type: SET_MODEL, model });

export type ModelActionsType = SetModelType;
